import { type ReactNode, type ReactElement } from 'react';
import cn from 'classnames';

import styles from './tile.module.scss';

interface ITileBodyProps {
  children?: ReactNode,
  className?: string,
  dataTest?: string,
}

const TileBody = ({ children, className, dataTest }: ITileBodyProps): ReactElement => (
  <div className={ cn(styles.body, className) } data-test={ dataTest }>
    { children }
  </div>
);

export { TileBody };
export type { ITileBodyProps };
